import React from "react";
import {ItemStackProps} from "./ItemStack";
import {IODirection} from "../Enum/IODirection";
import {FactoryGameType, ItemStack as ItemStackType} from "../types";
import './IOSummary.sass';

type Props = {
    gameType: FactoryGameType,
    ingredients: ItemStackType[],
    products: ItemStackType[],
    InputChildren?: React.FC,
    OutputChildren?: React.FC,
    StackRender: React.FC<ItemStackProps>,
};

export function IOSummary({gameType, ingredients, products, StackRender, InputChildren = () => null, OutputChildren = () => null}: Props) {
    return <div className='ioContainer'>
        <div className='facilityIO'>
            {ingredients.map((itemStack, i) =>
                <StackRender key={i} item={itemStack.item} amount={itemStack.amount} gameType={gameType} direction={IODirection.Input}>
                    <InputChildren />
                </StackRender>)}
        </div>
        <div className='facilityIO'>
            {products.map((itemStack, i) =>
                <StackRender key={i} item={itemStack.item} amount={itemStack.amount} gameType={gameType} direction={IODirection.Output}>
                    <OutputChildren />
                </StackRender>)}
        </div>
    </div>
}
